export const defaultStyle = {

}

export const TREND_RADAR_CHART = {
  radarWrapper:"max-width-wrapper font-BwSurco outline-none  px-35 mt-25 lg:mt-0 md:px-15 lg:pt-50 bg-white overflow-hidden transition-all duration-500",
  fullScreenMode:"lg:fixed  lg:top-0 lg:left-0 lg:z-[100] pb-50 lg:max-w-full lg:w-screen lg:h-full  lg:!overflow-y-auto lg:!m-0",
  container:" lg:pb-10 ",
  heading:"hidden  lg:block font-BwSurcoBold lg:px-35 text-18 w-full leading-[1.334] text-purple font-bold",
  description:"hidden lg:block lg:px-35 pb-15 text-18 font-semibold leading-[1.334] border-b border-b-gray/50",
  chartContainer:"lg:py-20 lg:px-35 min-h-[100px] lg:min-h-[200px] lg:relative flex flex-col lg:block",
  fullScreenBtn:`hidden lg:flex text-purple text-18 underline leading-[1.333] mt-0 lg:absolute lg:top-30 lg:left-35 cursor-pointer items-center
  before:inline-block before:content-[""] before:w-[16px] before:h-[24px] before:bg-fullscreenIcon before:bg-no-repeat before:bg-center before:mr-2`,
  radar:"mx-auto font-BwSurcoBold transition-all duration-300 my-40 lg:my-0",
  legendWrapper:"legendWrapper hidden font-BwSurcoBold lg:block pt-4 absolute bottom-10 right-35 border-t border-black",
  legendHeading:"text-12 uppercase font-medium  leading-[1]",
  lengends:"flex items-center gap-x-15",
  legend:" text-10 leading-none font-medium flex items-center",
  legendNotation:"inline-block rounded-[50%] bg-black mr-1",
  hint:`hint text-16 py-8 pl-4 pr-12 font-bold lg:font-normal leading-[1.5] lg:leading-[1.1] lg:font-BwSurcoBold  uppercase lg:normal-case lg:absolute lg:mb-0 lg:top-30 lg:right-35 w-full lg:w-[224px] border-gray/80 border-1 rounded-xl 
  before:inline-block before:content-[""] before:w-[40px] before:h-[40px] bgIcon lg:before:w-[30px] lg:before:h-[30px] lg:before:scale-[calc(120/100)] before:bg-no-repeat before:bg-center before:bg-clickArrowIcon before:shrink-0
  flex items-center justify-center gap-x-10 lg:gap-x-4`,
  desktopModalWrapper:"",
  relatedTrendsWrapper:"relatedTrendsWrapper mt-40 pt-18 lg:pt-28",
  relatedTrendsHeading:"text-18 lg:text-24 leading-[1.777] lg:leading-[1.333]",
  relatedTrends:"mt-24",
  relatedTrend:`mb-40 w-fit last:mb-0 cursor-pointer flex items-center gap-x-10`,
  relatedTrendBullet:"inline-block w-[15px] h-[15px] shrink-0 rounded-[50%] border-1",
  relatedTrendLabel:"font-MDLZBiteType font-normal text-[24px] lg:text-[32px] leading-none underline",
  desktopModalShortDescription:""
}